import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Addable }         from '@widesk-core/decorators/addable';
import { Editable }        from '@widesk-core/decorators/editable';
import { Deletable }       from '@widesk-core/decorators/deletable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.path('/figures/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractFigureModel extends Blamable(WebsiteServiceModel) {
	declare protected _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'name': id;
		'firstname': id;
		'title': id;
		'country': string;
		'figureProfessions.profession': id;
		'search': string;
	};

	declare private _tsSorts: {
		id: string;
		name: string;
		firstname: string;
		title: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare name: string;
	@doc.string declare firstname: string;
	@doc.string declare title: string;
	@doc.number declare birthDay: number;
	@doc.number declare birthMonth: number;
	@doc.number declare birthYear: number;
	@doc.string declare country: string;
}

interface AbstractFigureModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractFigureModel;
